module.exports = __webpack_public_path__ + "static/Karo-40523e0054684b57846ea93bc35be38e.mp4";